import React, { PropTypes } from 'react';
import { Dialog, IconButton } from 'material-ui';
import LoginForm from './login';
import Warning from './warning';
import Success from './success';
import SignupForm from '../../contracting-sign-up/signup-form';
import SignUpButton from '../../contracting-sign-up/signup-button';
import DLWizard from './wizards/dl-wizard-container';
import SendRateswizard from './wizards/send-rates-wizard-container';
import { connect } from 'react-redux';
import {
  closeDialog as closeDialogAction,
  login,
  updateDialogProps as updateDialogPropsAction,
  autoLogin,
  signupFn as signupFnAction,
  scheduleDemo,
  requestEzLoadAction,
  sendRatesAction,
} from '../__storeFiles__/actions';
import { openHelpWidget } from '../../../stores/ui/components/helpwidget/helpwidget-actions';

const propTypes = {
  showwarning: PropTypes.bool,
  success: PropTypes.bool,
  type: PropTypes.string,
  signupFn: PropTypes.func,
  closeDialog: PropTypes.func,
  open: PropTypes.bool,
  error: PropTypes.bool,
  displayMsg: PropTypes.string,
  allRequests: PropTypes.array,
  files: PropTypes.array,
  updateDialogProps: PropTypes.func,
  userId: PropTypes.string,
  requestEzLoad: PropTypes.func,
  sendRates: PropTypes.func,
};

const AssetLandingDialog = props => {
  const {
    showwarning,
    type,
    signupFn,
    open,
    closeDialog,
    displayMsg,
    error,
    updateDialogProps,
    userId,
    requestEzLoad,
    sendRates,
  } = props;
  const content = (() => {
    if (type === 'login') {
      if (showwarning) {
        return (<Warning{...props}/>);
      }
      return (<LoginForm {...props}/>);
    }
    if (type === 'signup') {
      if (props.success) {
        if (showwarning) {
          return (<Warning {...props}/>);
        }
        return (
          <Success {...props} />
        );
      }
      return (<div style={{ padding: '16px' }}>
        <SignupForm/>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <SignUpButton
            signupFn={signupFn}
          />
        </div>
      </div>);
    }
    if (type === 'dl-wizard') {
      return (
        <DLWizard
          hasAccount={Boolean(userId)}
          signupFn={signupFn}
          updateDialogProps={updateDialogProps}
          requestEzLoad={requestEzLoad}
          {...props}
        />
      );
    }
    if (type === 'send-rates') {
      return (
        <SendRateswizard
          updateDialogProps={updateDialogProps}
          sendRates={sendRates}
          {...props}
        />
      );
    }
  })();
  return (
    <Dialog
      open={Boolean(open)}
      onRequestClose={closeDialog}
      modal
      autoScrollBodyContent
      contentStyle={{ transform: 'none', width: type === 'dl-wizard' || type === 'send-rates' ? '850px' : '550px' }}
      titleStyle={{ padding: 0, border: 'none' }}
      title={
        <div className="flex-tc-sb">
          <div/>
          <IconButton
            iconClassName="tc-icon-close"
            iconStyle={{ color: 'red', fontSize: '32px' }}
            onTouchTap={closeDialog}
          />
        </div>
      }
    >
      {
        error && (
          <div style={{ color: 'red' }}>
            {displayMsg}
          </div>
        )
      }
      {content}
    </Dialog>
  );
};

AssetLandingDialog.propTypes = propTypes;

export default connect(null, {
  closeDialog: closeDialogAction,
  login,
  updateDialogProps: updateDialogPropsAction,
  autoLogin,
  signupFn: signupFnAction,
  openHelpWidget,
  scheduleDemo,
  requestEzLoad: requestEzLoadAction,
  sendRates: sendRatesAction,
})(AssetLandingDialog);



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/dialog/dialog.jsx